import { render, staticRenderFns } from "./MainNavigator.vue?vue&type=template&id=60075afe&scoped=true&"
import script from "./MainNavigator.vue?vue&type=script&lang=js&"
export * from "./MainNavigator.vue?vue&type=script&lang=js&"
import style0 from "./MainNavigator.vue?vue&type=style&index=0&id=60075afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60075afe",
  null
  
)

export default component.exports